// Featured-products redesign exploration, variant 1: "Editorial".
// Magazine-style curation — every category becomes a spread with an
// oversized lead card (the latest pick, native aspect ratio) and a
// supporting grid. A single sticky control row holds the category pills
// (scrollspy) plus a contextual "View all" link; no per-section headers.
angular.module("UI8.components").component("featuredEditorial", {
  template: `<div class="page fedit">
      <div class="page__sphere" id="fedit-sphere"></div>
      <div class="page__container container">
        <header class="fedit__masthead">
          <h1 class="fedit__title"><span class="fedit__word">Featured<span class="fedit__seal" id="fedit-seal"><svg class="fedit__seal-badge" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M2.0315 12C2.0312 11.8662 2.00492 11.7325 1.95265 11.6065L1.23121 9.85975C1.07879 9.49188 1.00006 9.09699 1 8.69879C0.999936 8.30038 1.07838 7.90585 1.23084 7.53776C1.3833 7.16967 1.6068 6.83523 1.88856 6.55355C2.17025 6.27194 2.50465 6.04858 2.87267 5.89623L4.6166 5.17384C4.86916 5.06941 5.0706 4.86887 5.17575 4.61659L5.8983 2.87214C6.20608 2.12905 6.79645 1.53866 7.53953 1.23085C8.28261 0.923049 9.11753 0.923048 9.86061 1.23085L11.6037 1.9529C11.8567 2.05733 12.141 2.0572 12.3938 1.95231L12.3958 1.95149L14.1404 1.23192C14.8832 0.924529 15.7183 0.924429 16.4611 1.23209C17.204 1.53984 17.7943 2.13006 18.1021 2.87295L18.8073 4.57552C18.8136 4.58896 18.8196 4.60259 18.8253 4.61641C18.9298 4.86924 19.1304 5.07024 19.383 5.1753L21.1279 5.8981C21.871 6.20591 22.4614 6.7963 22.7692 7.53939C23.0769 8.28247 23.0769 9.11739 22.7692 9.86048L22.0468 11.6045C21.9943 11.7311 21.9681 11.8661 21.9681 12.0003C21.9681 12.1345 21.9943 12.2689 22.0468 12.3955L22.7692 14.1395C23.0769 14.8826 23.0769 15.7175 22.7692 16.4606C22.4614 17.2037 21.871 17.7941 21.1279 18.1019L19.383 18.8247C19.1304 18.9298 18.9298 19.1308 18.8253 19.3836C18.8196 19.3974 18.8136 19.411 18.8073 19.4245L18.1021 21.127C17.7943 21.8699 17.204 22.4602 16.4611 22.7679C15.7183 23.0756 14.8832 23.0755 14.1404 22.7681L12.3958 22.0485L12.3938 22.0477C12.141 21.9428 11.8567 21.9427 11.6037 22.0471L9.86061 22.7691C9.11753 23.077 8.28261 23.077 7.53953 22.7691C6.79645 22.4613 6.20608 21.8709 5.8983 21.1279L5.17575 19.3834C5.0706 19.1311 4.86916 18.9306 4.6166 18.8262L2.87267 18.1038C2.50465 17.9514 2.17025 17.7281 1.88856 17.4465C1.6068 17.1648 1.3833 16.8303 1.23084 16.4622C1.07838 16.0941 0.999936 15.6996 1 15.3012C1.00006 14.903 1.07879 14.5081 1.23121 14.1402L1.95265 12.3935C2.00492 12.2675 2.0312 12.1338 2.0315 12Z" fill="#00A656"/>
          </svg><svg class="fedit__seal-check" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8.5 12L10.5 14L15.5 9" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span></span></h1>
          <div class="fedit__standfirst">The newest resources to earn our seal of approval, hand-picked by the UI8 team and refreshed daily.</div>
        </header>
      </div>
      <div class="fedit__navwrap" id="fedit-navwrap">
        <nav class="fedit__nav container">
          <div class="fedit__pills">
            <button class="fedit__pill" ng-repeat="section in ::$ctrl.sections track by section.slug" data-section="{{ ::section.slug }}">{{ ::section.name }}</button>
          </div>
        </nav>
      </div>
      <div class="page__container container">
        <section class="fedit__section" ng-repeat="section in ::$ctrl.sections track by section.slug" ng-class="{'fedit__section--flip': $index % 2}">
          <div class="fedit__anchor" id="{{ ::section.slug }}"></div>
          <div class="fedit__grid">
            <div class="fedit__leadcol">
              <div class="fedit__lead">
                <div class="fedit__badge">Latest pick</div>
                <product-card product="::section.lead" user="::$ctrl.user"></product-card>
              </div>
              <div class="fedit__panel">
                <div class="fedit__cat">
                  <svg class="fedit__icon" viewBox="0 0 40 40" ng-if="::section.icon" data-icon="{{ ::section.icon }}"></svg>
                  <h2 class="fedit__subtitle">{{ ::section.name }}</h2>
                </div>
                <a class="fedit__all" ng-href="/category/{{ ::section.slug }}" ng-click="$ctrl.viewAll(section.slug)">View all<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a>
              </div>
            </div>
            <div class="fedit__rest">
              <product-card ng-repeat="product in ::section.rest track by product._id" product="::product" user="::$ctrl.user"></product-card>
            </div>
          </div>
        </section>
      </div>
    </div>`,

  controller: function ($scope, HistoryService) {
    var ctrl = this;
    var sphere = null;
    var sphereObserver = null;

    // SVG symbols from the header "Browse by category" menu (menu.jade)
    var CATEGORY_ICONS = {
      "ui-kits": "#browse-1",
      "coded-templates": "#browse-2",
      "no-code": "#browse-3",
      mockups: "#browse-4",
      "3d-assets": "#browse-5",
      themes: "#browse-6",
      presentation: "#browse-7",
      icons: "#browse-8",
      illustrations: "#browse-9",
      fonts: "#browse-10",
    };

    ctrl.$onInit = function () {
      var categories = ctrl.data || [];

      ctrl.sections = [];

      categories.forEach(function (category) {
        var products = category.products || [];
        if (!products.length) return;

        ctrl.sections.push({
          name: category.name,
          slug: category.slug,
          icon: CATEGORY_ICONS[category.slug],
          lead: products[0],
          rest: products.slice(1, 5),
        });
      });

      var top = getTop();
      $(document).ready(function () {
        window.scroll(0, top);

        // Same interactive sphere as the homepage hero, paused off-screen
        var sphereEl = document.getElementById("fedit-sphere");
        if (sphereEl) {
          (function waitForHero() {
            if (window.HeroSphere && window.HeroSphere.initHero) {
              sphere = window.HeroSphere.initHero(
                sphereEl,
                "/img/cards/",
                null,
                30
              );
              sphereObserver = new IntersectionObserver(function (entries) {
                if (!sphere || !sphere.pause) return;
                if (entries[0].isIntersecting) sphere.resume();
                else sphere.pause();
              });
              sphereObserver.observe(sphereEl);
            } else {
              requestAnimationFrame(waitForHero);
            }
          })();
        }

        // Angular can't bind xlink:href with the proper namespace, so the
        // <use> referencing the header menu's category sprite is added here
        $(".fedit__icon").each(function () {
          var use = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "use"
          );
          use.setAttributeNS(
            "http://www.w3.org/1999/xlink",
            "href",
            $(this).data("icon")
          );
          this.appendChild(use);
        });

        var $header = $(".header"),
          $navwrap = $("#fedit-navwrap"),
          $page = $(".fedit"),
          $links = $page.find(".fedit__pill"),
          $anchors = $page.find(".fedit__anchor"),
          navTop = $navwrap.offset().top,
          activeIndex = -1;

        // Scroll-driven seal spin: 0.35deg per px, capped so it keeps a
        // playful tilt rather than whirling. rAF-throttled.
        var sealEl = document.getElementById("fedit-seal"),
          sealTicking = false;

        function updateSeal() {
          sealTicking = false;
          if (!sealEl) return;
          var spin = Math.min($(window).scrollTop() * 0.35, 340);
          sealEl.style.setProperty("--seal-spin", spin + "deg");
        }

        function setActive(i) {
          if (i === activeIndex) return;
          activeIndex = i;
          $links.removeClass("active").eq(i).addClass("active");
        }

        setActive(0);

        $links.on("click", function (e) {
          e.preventDefault();
          var id = $(this).data("section");
          window.scroll(0, $("#" + id).offset().top);
        });

        $(window).on("scroll.fedit", function () {
          var posScroll = $(window).scrollTop();

          if (!sealTicking) {
            sealTicking = true;
            requestAnimationFrame(updateSeal);
          }

          if (posScroll + $header.outerHeight() >= navTop) {
            $navwrap.addClass("scrolled");
          } else {
            $navwrap.removeClass("scrolled");
          }

          var windowHeight = $(window).height();
          $anchors.each(function (i) {
            var posTop = $(this).offset().top,
              height = $(this).parent().outerHeight();

            if (
              posScroll + windowHeight / 2 > posTop &&
              posScroll + windowHeight / 2 < posTop + height
            ) {
              setActive(i);
            }
          });
        });
      });

      function isGoingToProduct(oldPath, oldUrl) {
        return (
          oldPath.startsWith("/category/featured-products") &&
          !oldUrl.includes("?search=1")
        );
      }

      HistoryService.rememberScrollPosition(isGoingToProduct, "featured-v1");
    };

    // Unbind the window scroll handler and stop the sphere when the
    // component is torn down on SPA navigation
    $scope.$on("$destroy", function () {
      $(window).off("scroll.fedit");
      if (sphereObserver) sphereObserver.disconnect();
      if (sphere && sphere.pause) sphere.pause();
    });

    // Pre-arm the category page's Featured toggle (it initializes itself
    // from this sessionStorage key), so View all lands on featured-only
    ctrl.viewAll = function (slug) {
      sessionStorage.setItem(slug + ":category-featured-filter", "true");
    };

    function getTop() {
      var top = sessionStorage.getItem("top:featured-v1") || 0;
      sessionStorage.removeItem("top:featured-v1");
      return parseInt(top, 10);
    }
  },

  bindings: {
    data: "<",
    user: "<",
  },
});
